/**
 * This is a polyfill library that enables IE 11 to run modern websites
 * Do not use Babel as it conflicts with Google Maps API library
 */
 import "core-js/stable";
 import "regenerator-runtime/runtime";

 /**
  * First we will load all of this project's JavaScript dependencies which
  * includes Vue and other libraries. It is a great starting point when
  * building robust, powerful web applications using Vue and Laravel.
  */

 require('./bootstrap');
 require('magnific-popup');
 require('./scripts/common');



 window.Vue = require('vue');
 import store from './store';
 import Slick from 'vue-slick'
 import vueDebounce from 'vue-debounce'
 import { BPagination } from 'bootstrap-vue'
 import VueDayjs from 'vue-dayjs-plugin'
 import * as VueGoogleMaps from 'vue2-google-maps'
 import GmapCluster from 'vue2-google-maps/dist/components/cluster'

 Vue.use(VueGoogleMaps, {
   load: {
     key: 'AIzaSyAyyBGgGqqYHmQrgrGSrnzYCjYj45w3e8Q', // this should not be hardcoded, component using maps should have a props to receive maps key
     libraries: 'places'
   }
 })
 Vue.component('GmapCluster', GmapCluster)
 Vue.component('b-pagination', BPagination)
 Vue.use(vueDebounce)
 Vue.use(VueDayjs)

 /**
  * Next, we will create a fresh Vue application instance and attach it to
  * the page. Then, you may begin adding components to this application
  * or customize the JavaScript scaffolding to fit your unique needs.
  */

 Vue.component('app-header', require('./components/Header.vue'));
 Vue.component('sub-header', require('./components/SubHeader.vue'));
 Vue.component('app-footer', require('./components/Footer.vue'));
 Vue.component('app-page-loader', require('./components/PageLoader.vue'));
 Vue.component('app-page-title', require('./components/PageTitle.vue'));
 Vue.component('app-popup-modal', require('./components/PopupModal.vue'));
 Vue.component('app-notice', require('./components/PageNotice.vue'));
 Vue.component('app-collapsible', require('./components/Collapsible.vue'));
 Vue.component('app-expandable', require('./components/Expandable.vue'));
 Vue.component('app-location-expert', require('./components/LocationExpert.vue'));

 Vue.component('app-contact-form', require('./components/ContactForm.vue'));
 Vue.component('app-google-review', require('./components/GoogleReview.vue'));

 Vue.component('home-search', require('./components/HomeSearch.vue'));

 // BOOK NOW SEARCH
 Vue.component('app-book-now', require('./components/book-now/Index.vue'));

 // MEMBERSHIPS
 Vue.component('app-memberships', require('./components/memberships/Index.vue'));

 // ACC PROGRAMMES
 Vue.component('app-acc-programmes', require('./components/acc-programmes/Index.vue'));

 // Similiar Lists
 Vue.component('app-news-list', require('./components/news/Index.vue'));
 Vue.component('app-special-offers', require('./components/special-offers/Index.vue'));
 Vue.component('app-client-stories-list', require('./components/client-stories/Index.vue'));

 // LOCATIONS
 //Vue.component('app-locations', require('./components/locations/Index.vue'));
 Vue.component('app-locations-map', require('./components/locations/IndexWithMap.vue'));
 Vue.component('app-icp-map', require('./components/locations/IcpIndexWithMap.vue'));
 Vue.component('app-map', require('./components/locations/Map.vue'));
 Vue.component('app-map-2', require('./components/locations/Map2.vue'));

 // BUSINESS TEAM
 Vue.component('app-business-team', require('./components/business-team/Index.vue'));

 // MEET OUR EXPERTS
 Vue.component('app-meet-experts', require('./components/meet-experts/Index.vue'));


 const app = new Vue({
   el: '#app',
   components: { Slick },
   store,
   data () {
     return {
       isLoaded: false,
       isMenuOpen: false
     }
   },
   mounted () {
     this.$store.state.is_loading = false

     this.$on('emitMenuToggle', function(value){
       this.isMenuOpen = value
     })

     setTimeout(() => {
       this.isLoaded = true
     }, 200)
   }
 });


// WEBPACK FOOTER //
// ./resources/assets/frontend/js/app.js